<template>
  <div class="flex-center">
    <v-btn v-if="multipleAction" class="ml-3" @click.stop="onTuition" color="amber darken-1" dark>
      <v-icon left>mdi-file-document</v-icon>Tạo Học Phí
    </v-btn>
    <span class="ml-3" v-if="selected.length > 0"><StudentEditTags :students="selected" /></span>
    <v-btn class="ml-1" v-if="multipleAction" @click.stop="onActivate" color="primary" dark>
      <v-icon left>mdi-account-check</v-icon>Kích Hoạt
    </v-btn>
    <UpsertReservationDialog
      v-if="upsertReservationDialog.isOpen"
      :isOpen="upsertReservationDialog.isOpen"
      :isEdit="upsertReservationDialog.isEdit"
      :currentItem="upsertReservationDialog.currentItem"
      @close="upsertReservationDialog.onCancel"
      @cancel="upsertReservationDialog.onCancel"
      @confirm="upsertReservationDialog.callback"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import StudentEditTags from '@/modules/student/StudentEditTags.vue'
import _ from 'lodash'
import UpsertReservationDialog from '@/components/UpsertReservationDialog.vue'
import moment from 'moment'
export default {
  components: {
    StudentEditTags,
    UpsertReservationDialog
  },
  props: {
    disabled: Boolean,
    filter: Boolean,
    selected: { type: Array, default: () => [] }
  },
  data() {
    return {
      upsertReservationDialog: {
        currentItem: null,
        isOpen: false,
        callback: () => {},
        onCancel: () => {
          this.upsertReservationDialog.isOpen = false
          this.upsertReservationDialog.isEdit = false
          this.upsertReservationDialog.currentItem = null
        }
      },

      mailDialogState: false,
      smsDialogState: false,
      smsEditingState: false,
      createState: false,
      sending: null
    }
  },
  computed: {
    ...mapState('student', ['students']),
    sendingName() {
      const { name } = this.students.find(student => student.phone === this.sending)
      return name
    },
    multipleAction() {
      return !_.isEmpty(this.selected)
    }
  },
  methods: {
    ...mapActions('students', ['removeStudents', 'updateStudents', 'requestPageSettings']),
    ...mapActions('noti', ['sendEmails', 'sendSMS']),
    ...mapActions('sale', ['setStudents']),
    disableStudent() {
      this.updateStudents(
        this.selected.map(item => {
          return { ...item, status: 'block' }
        })
      )
    },
    enableStudent() {
      this.updateStudents(
        this.selected.map(item => {
          return { ...item, status: 'active' }
        })
      )
    },
    onRemove() {
      this.$dialog.confirm({
        title: 'Xóa Học Sinh',
        text: 'Bạn có chắc muốn xóa học sinh này',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.removeStudents(this.selected)
          this.$emit('removed')
        }
      })
    },
    onReserve() {
      // this.$dialog.confirm({
      //   title: 'Bảo Lưu Học sinh',
      //   text: 'Bạn có muốn bảo lưu những học sinh này ?',
      //   okText: 'Có',
      //   cancelText: 'Không',
      //   done: async () => {
      //     await this.updateStudents(this.selected.map(s => ({ id: s.id, status: 'reserved' })))
      //     this.$emit('removed')
      //   }
      // })

      let data = {
        student: '',
        start_date: moment().startOf('day').toISOString(),
        end_date: undefined,
        process_completion_date: undefined,
        reason: '',
        note: '',
        reason_type: '',
        tuition_status: '',
        new_class: '',
        return_date: undefined,
        actual_return_date: undefined,
        new_class_date: undefined
      }
      this.upsertReservationDialog.currentItem = data
      this.upsertReservationDialog.isOpen = true
      this.upsertReservationDialog.callback = (async payload => {
        try {
          await this.createReservation({
            params: payload
          })
          this.$alert.success('Tạo thành công')
          await this.fetchStudent(
            this.upsertReservationDialog.currentItem.student.id ||
              this.upsertReservationDialog.currentItem.student
          )
        } catch (error) {
          console.error(error)
          this.$alert.error('Có lỗi xay ra')
        } finally {
          this.upsertReservationDialog.isOpen = false
        }
      }).bind(this)
    },
    onTuition() {
      this.setStudents(this.selected)
      this.$router.push('./sales')
    },
    onActivate() {
      this.$dialog.confirm({
        title: 'Bảo Lưu Học sinh',
        text: 'Bạn có muốn chuyển trạng thái học viên này về đang hoạt động ?',
        okText: 'Có',
        cancelText: 'Không',
        done: async () => {
          await this.updateStudents(this.selected.map(s => ({ id: s.id, status: 'active' })))
          this.$emit('removed')
        }
      })
    }
  }
}
</script>
